import ButtonBase from '@material-ui/core/ButtonBase';
import LinkItem from 'components/Atoms/LinkItem';
import { Link } from 'gatsby';
import React from 'react';
import tw from 'twin.macro';

export default function TaleButton({ to, title, Icon, Description, isBackground, ...props }) {
	return (
		<ButtonBase
			tw='flex flex-col items-start justify-center py-10 px-20'
			css={[isBackground && tw`bg-grey-F border-t border-b border-solid border-grey-D`]}
			component={Link}
			to={to}
			{...props}
		>
			<div className='flex items-center justify-start py-07'>
				{Icon}<p className='text-16 px-15'>{title}</p>
			</div>
			<div className='text-left py-10'>{Description}</div>
			<div className='w-full flex items-center justify-end'><LinkItem to={to} /></div>
		</ButtonBase>
	);
}
